import styled from '@emotion/styled'

import type { FC } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Navigation from '@segment/templates/Navigation'
import Footer from '@segment/templates/Footer'
import DividerSection from '@segment/templates/DividerSection'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import TopDestinationCategories from './components/TopDestinationCategories'
import Categories from './components/Categories'
import Introduction from './components/Introduction'
import GetCustomerEngagementStack from './components/GetCustomerEngagementStack'
import Subnavigation from './components/Subnavigation'

const copy = {
  title: `The Customer Engagement Stack | Twilio Segment`,
  description: `Learn about the types of technology and specific applications that top brands use to power their Customer Engagement Stacks.`,
}

const CustomerEngagementStackView: FC = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout pageTitle={copy.title} pageDescription={copy.description}>
        <Navigation after={<Subnavigation />} />
        <Main>
          <Hero />
          <Introduction />
          <TopDestinationCategories />
          <Categories />
          <DividerSection />
          <GetCustomerEngagementStack />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default CustomerEngagementStackView
